import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PlanoContasEmpresaDetalharComponent } from './plano-contas-empresa-detalhar.component';

const routes: Routes = [];

@NgModule({
  imports: [RouterModule.forChild([
    {path:':id', component: PlanoContasEmpresaDetalharComponent}
  ])],
  exports: [RouterModule]
})
export class PlanoContasEmpresaDetalharRoutingModule { }
